import {Form, Input, Row, Col, DatePicker, InputNumber, Select} from 'antd';
import React, {useContext, useEffect} from 'react';
import WangEditor from "../common/WangEditor";
import {sideMenuContext} from "../../../router/IndexRouter";
import AddFormComponent from "../common/AddFormComponent";
import EditFormComponent from "../common/EditFormComponent";
import {Arguments} from "../common/Arguments";
import SaveButtonComponent from "../common/SaveButtonComponent";
import {validateEditorContent, validateWhiteSpace} from "../common/ValidateWhiteSpace";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};
const tailLayout = {
    wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef()

const AddInformation = () => {
    const currentUrl = window.location.href;
    // 获取 WangEditor 中的内容
    const {editorContent} = useContext(sideMenuContext);
    const apiList = [Arguments.host + "/society_organization/policy/api!addInformation.do"];

    useEffect(() => {
        formRef.current.setFieldsValue({
            notificationContent: editorContent
        })
    }, [editorContent])

    return (currentUrl.endsWith("add") ? <AddFormComponent UserForm={MeetingNoticeForm} url={apiList}/> :
            <EditFormComponent UserForm={MeetingNoticeForm} url={apiList}/>
    )
}

const MeetingNoticeForm = ({onFinish, initialValues}) => {
    const [form] = Form.useForm();

    return (
        <Form
            {...layout}
            form={form}
            onFinish={onFinish}
            initialValues={initialValues}
            name="control-hooks"
            style={{maxWidth: 1200, marginLeft: 40}}
            ref={formRef}
        >
            <Row align='top'>
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="title" label="标题"
                        rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={12}>
                    <Form.Item
                        name="status" label="是否有效"
                        rules={[{required: true, message: '内容不能为空'}]}
                        initialValue="是"
                    >
                        <Select>
                            <Select.Option value="是">是</Select.Option>
                            <Select.Option value="否">否</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="publishDate" label="发布日期" rules={[{required: true, message: '内容不能为空'}]}>
                        <DatePicker placeholder="选择日期"/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align='top'>
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="notificationContent" label="详细信息"
                        rules={[{required: true, validator: validateEditorContent}]}>
                        <WangEditor defaultValue={initialValues?.notificationContent}/>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item {...tailLayout}>
                <SaveButtonComponent/>
            </Form.Item>
        </Form>
    )
}

export default AddInformation;